import React from 'react'
import RadioButton from '@/components/RadioButton'

const CheckBoxCollection = ({ classStyles, btnName, handleClick, checked }) => (
    <RadioButton
        btnName={btnName}
        classStyles={classStyles + ' ' + (checked ? 'nav__collection' : 'nav__collection-button-unchecked')}
        handleClick={() => handleClick()}
        cancelBg={undefined}
    />
)

export default CheckBoxCollection
